export function formatDatetime(
  date: Date | string | undefined | null,
  exludeTime?: boolean
): string {
  if (!date) return '';
  if (exludeTime) {
    return new Date(date).toLocaleDateString('en-GB');
  } else
    return new Date(date).toLocaleString('en-GB', {
      dateStyle: 'short',
      timeStyle: 'short',
    });
}

export function dateFormatter(value: string | undefined | Date | null): string {
  if (value === undefined || value === '' || value === null) {
    return '-';
  }

  return new Date(value).toLocaleDateString();
}

export function formatDatetimeShort(
  date: Date | string | undefined | null,
  exludeTime?: boolean
): string {
  if (!date) return '';
  if (exludeTime) {
    return new Date(date).toLocaleDateString('en-GB');
  } else
    return new Date(date).toLocaleString('en-GB', {
      dateStyle: 'short',
      timeStyle: 'short',
    });
}
